/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ChangeDetectorRef } from '@angular/core';

import { UntypedFormGroup } from '@angular/forms';
import { Tab } from '../../../core/model/tab.model';

/**
 * @export
 * @class QueryViewFilterCommodityComponent
 * @implements {OnInit}
 * @implements {OnChanges}
 */
@Component({
  selector: 'lms-query-view-filter-commodity',
  templateUrl: './query-view-filter-commodity.component.html',
  styleUrls: ['./query-view-filter-commodity.component.scss']
})
export class QueryViewFilterCommodityComponent implements OnInit, OnChanges {
  @Input() group: any;
  @Input() commonopsPicklist;
  @Input() commodityError;
  @Input() tab: Tab;
  @Input() tabIndex: number;
  @Output() resetCommodityError = new EventEmitter();
  commodityList;
  commodityForm: UntypedFormGroup;
  @Input() selectedAll;
  isSelectAllChecked: boolean = false;
  commodity = ['intermodalComm', 'coalComm', 'liteEngComm', 'foreignComm', 'autoComm', 'emptyComm', 'extraTrainComm', 'passengerComm', 'qMerchandise', 'grainComm', 'workTrainComm', 'otherComm', 'localComm', 'bulkComm'];

  constructor(private cdr: ChangeDetectorRef) {
    this.getCommodityList();
  }

  /**
   * @memberof QueryViewFilterCommodityComponent
   */
  ngOnChanges() {
    this.commodityForm = this.group;
    this.checkSelectedValues(true, true);
  }

  /**
   * @memberof QueryViewFilterCommodityComponent
   */
  ngOnInit() {
    this.checkSelectedValues(true);
  }


  /**
   * set all commodity list with their value and label
   * @memberof QueryViewFilterCommodityComponent
   */
  getCommodityList() {
    this.commodityList = [{
      label: 'Intermodel',
      value: 'intermodalComm',
      className: 'intermodel'
    },
    {
      label: 'Coal',
      value: 'coalComm',
      className: 'coal'
    },
    {
      label: 'Light Engine',
      value: 'liteEngComm',
      className: 'light-engine'
    },
    {
      label: 'Foreign',
      value: 'foreignComm',
      className: 'foreign'
    },
    {
      label: 'Automotive',
      value: 'autoComm',
      className: 'automotive'
    },
    {
      label: 'Empty Coal',
      value: 'emptyComm',
      className: 'empty-coal'
    },
    {
      label: 'Extra',
      value: 'extraTrainComm',
      className: 'extra'
    },
    {
      label: 'Passenger',
      value: 'passengerComm',
      className: 'passenger'
    },
    {
      label: 'Merch Q/L',
      value: 'qMerchandise',
      className: 'merch'
    },
    {
      label: 'Grain',
      value: 'grainComm',
      className: 'grain'
    },
    {
      label: 'Work',
      value: 'workTrainComm',
      className: 'work'
    },
    {
      label: 'Other',
      value: 'otherComm',
      className: 'other'
    },
    {
      label: 'Local',
      value: 'localComm',
      className: 'local'
    },
    {
      label: 'Bulk Merch',
      value: 'bulkComm',
      className: 'bulk-merch'
    }];
  }

  /**
   * on every commodity check box change that
   * total checkbox check if yes then selectall set checked else not
   * @param {any} checked
   * @memberof QueryViewFilterCommodityComponent
   */
  checkSelectedValues(checked, byOnChange?: boolean) {
    if (this.commodityError && !byOnChange) {
      this.resetCommodityError.emit({ value: false });
    }
    
    // Add null checks for commodityForm
    if (!this.commodityForm || !this.commodityForm.controls) {
      console.error('CommodityForm or controls not available in checkSelectedValues');
      return;
    }
    
    let counter = 0;
    for (let i = 0; i < this.commodity.length; i++) {
      const controlName = this.commodity[i];
      if (this.commodityForm.controls[controlName]) {
        const controlValue = this.commodityForm.controls[controlName].value;
        // Check for both boolean true and string 'Y' for backward compatibility
        if (controlValue === true || controlValue === 'Y') {
          counter++;
        }
      }
    }

    // Update the select all checkbox state
    this.isSelectAllChecked = (counter === this.commodity.length);
    
    // Keep the original selectedAll logic for backward compatibility
    if (counter === this.commodity.length) {
      this.selectedAll = ['selectAll'];
    } else {
      this.selectedAll = [];
    }
  }

  /**
   * select All functionality on checked select all commodity and viceversa
   * @param {any} event
   * @memberof QueryViewFilterCommodityComponent
   */
  toggleSelectAll(event) {
    // Now it should be a simple boolean from event.checked
    const isChecked = event.checked;
    this.isSelectAllChecked = isChecked;
    
    // Check if commodityForm and controls exist
    if (!this.commodityForm || !this.commodityForm.controls) {
      console.error('CommodityForm or controls not available');
      return;
    }
    
    if (isChecked) {
      if (this.commodityError) {
        this.resetCommodityError.emit({ value: false });
      }
      // Select all commodities using string 'Y'
      const patchObject = {};
      for (let i = 0; i < this.commodity.length; i++) {
        const controlName = this.commodity[i];
        if (this.commodityForm.controls[controlName]) {
          patchObject[controlName] = 'Y';
        }
      }
      this.commodityForm.patchValue(patchObject);
      this.selectedAll = ['selectAll'];
    } else {
      // Deselect all commodities using empty string
      const patchObject = {};
      for (let i = 0; i < this.commodity.length; i++) {
        const controlName = this.commodity[i];
        if (this.commodityForm.controls[controlName]) {
          patchObject[controlName] = '';
        }
      }
      this.commodityForm.patchValue(patchObject);
      this.selectedAll = [];
    }
    
    // Force change detection
    this.commodityForm.markAsDirty();
    this.commodityForm.updateValueAndValidity();
    this.cdr.detectChanges();
  }
}
